module.exports = __webpack_public_path__ + "img/NH_logo_colour.9f5f5987.png";